import React, { FC } from 'react';
import { useAccordionButton, AccordionContext } from 'react-bootstrap';
import { useContext } from 'react';

interface CustomAccordionBtnProps {
  children: React.ReactNode;
  eventKey: string;
}

export const CustomAccordionHeader: FC<CustomAccordionBtnProps> = (props) => {
  const { children, eventKey } = props;

  const { activeEventKey } = useContext(AccordionContext);
  const isOpen = activeEventKey === eventKey;

  const decoratedOnClick = useAccordionButton(eventKey);

  return (
    <div className="d-flex justify-content-between align-items-center py-2 px-2">
      <div className="w-75">{children}</div>
      <div
        onClick={decoratedOnClick}
        className={isOpen ? 'accordion-button' : 'collapsed accordion-button'}
      />
    </div>
  );
};
